class APIS {
    apis() {
        return {
            fetchThemes: {
                headers: {
                    'xt-user-token': null
                },
                method: 'post',
                path: '/backend/users/themes'
            },
            create_theme: {
                headers: {
                    'xt-user-token': null,
                    "Content-Type" : "application/json"
                },
                method: 'post',
                path: '/backend/users/create'
            },
            update_update: {
                headers: {
                    'xt-user-token': null
                },
                method: 'put',
                path: '/backend/users/themes'
            },
        }
    }
}

export default new APIS;